import {cloneDeep as _cloneDeep} from 'lodash';
import RoleModel from "./../../models/RoleModel"
const RolesModule = {
    namespaced: true,
    state: () => ({
        roles: [],
        role: _cloneDeep(RoleModel, true),
        permissions: [],
    }),
    getters: {
        getRoles (state) {
            return state.roles
        },
        getRole (state) {
            return state.role
        },
        getPermissions (state) {
            return state.permissions
        },
    },
    mutations: {
        setRoles (state, payload) {
            state.roles = payload
        },
        setRole (state, payload) {
            state.role = payload
        },
        setPermissions (state, payload) {
            state.permissions = payload
        },
    },
    actions: {
        setRoles (context, payload) {
            context.commit('setRoles', payload);
        },
        setRole (context, payload) {
            context.commit('setRole', payload);
        },
        setPermissions (context, payload) {
            context.commit('setPermissions', payload);
        },
    },

}

export default RolesModule;
